import React, {useEffect, useState} from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";

import ManIcon from '@mui/icons-material/Man';
import WomanIcon from '@mui/icons-material/Woman';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';

import CribIcon from '@mui/icons-material/Crib';
import ElderlyWomanIcon from '@mui/icons-material/ElderlyWoman';
import AutoGraphIcon from '@mui/icons-material/AutoGraph';
import RefreshIcon from '@mui/icons-material/Refresh';

// sales
import {Bar} from 'react-chartjs-2';
import {Button, Card, CardContent, CardHeader, Divider, Typography, useTheme} from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';

import {Doughnut} from 'react-chartjs-2';
import {useDispatch, useSelector} from "react-redux";
import {generateRandomHexColors, getAge, getInt, toDateTime} from "../utils/utils";
import {Loader} from "../components/loader";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import {getUsers} from "../ducks/user";
import {CACHE_KEY} from "../constants";
import Snackbar from "@material-ui/core/Snackbar/Snackbar";
import Alert from "@material-ui/core/Alert/Alert";


export const Insights = () => {

    return (
        <>
            <div
                id="recaptcha-container"
                className="justify-center flex"
            ></div>
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    py: 8
                }}
            >
                <Container maxWidth={false}>

                    <TotalUsers sx={{mb: 4}}/>

                    <Grid
                        container
                        spacing={3}
                    >
                        {/*<Grid*/}
                        {/*    item*/}
                        {/*    lg={8}*/}
                        {/*    md={12}*/}
                        {/*    xl={9}*/}
                        {/*    xs={12}*/}
                        {/*>*/}
                        {/*    <Sales/>*/}
                        {/*</Grid>*/}

                        {/*<Grid*/}
                        {/*    item*/}
                        {/*    lg={4}*/}
                        {/*    md={6}*/}
                        {/*    xl={3}*/}
                        {/*    xs={12}*/}
                        {/*>*/}
                        {/*    <TotalUsers sx={{height: '100%'}}/>*/}
                        {/*</Grid>*/}


                        <Grid
                            item
                            lg={4}
                            md={6}
                            xl={3}
                            xs={12}
                        >
                            <UsersByGender sx={{height: '100%'}}/>
                        </Grid>

                        <Grid
                            item
                            lg={4}
                            md={6}
                            xl={3}
                            xs={12}
                        >
                            <UsersByAgeRange sx={{height: '100%'}}/>
                        </Grid>

                        <Grid
                            item
                            lg={4}
                            md={6}
                            xl={3}
                            xs={12}
                        >
                            <UsersByState sx={{height: '100%'}}/>
                        </Grid>
                    </Grid>
                </Container>
            </Box>
        </>
    )
}


export const Sales = (props) => {
    const theme = useTheme();

    const data = {
        datasets: [
            {
                backgroundColor: '#3F51B5',
                barPercentage: 0.5,
                barThickness: 12,
                borderRadius: 4,
                categoryPercentage: 0.5,
                data: [18, 5, 19, 27, 29, 19, 20],
                label: 'This year',
                maxBarThickness: 10
            },
            {
                backgroundColor: '#EEEEEE',
                barPercentage: 0.5,
                barThickness: 12,
                borderRadius: 4,
                categoryPercentage: 0.5,
                data: [11, 20, 12, 29, 30, 25, 13],
                label: 'Last year',
                maxBarThickness: 10
            }
        ],
        labels: ['1 Aug', '2 Aug', '3 Aug', '4 Aug', '5 Aug', '6 Aug', '7 aug']
    };

    const options = {
        animation: false,
        cornerRadius: 20,
        layout: {padding: 0},
        legend: {display: false},
        maintainAspectRatio: false,
        responsive: true,
        xAxes: [
            {
                ticks: {
                    fontColor: theme.palette.text.secondary
                },
                gridLines: {
                    display: false,
                    drawBorder: false
                }
            }
        ],
        yAxes: [
            {
                ticks: {
                    fontColor: theme.palette.text.secondary,
                    beginAtZero: true,
                    min: 0
                },
                gridLines: {
                    borderDash: [2],
                    borderDashOffset: [2],
                    color: theme.palette.divider,
                    drawBorder: false,
                    zeroLineBorderDash: [2],
                    zeroLineBorderDashOffset: [2],
                    zeroLineColor: theme.palette.divider
                }
            }
        ],
        tooltips: {
            backgroundColor: theme.palette.background.paper,
            bodyFontColor: theme.palette.text.secondary,
            borderColor: theme.palette.divider,
            borderWidth: 1,
            enabled: true,
            footerFontColor: theme.palette.text.secondary,
            intersect: false,
            mode: 'index',
            titleFontColor: theme.palette.text.primary
        }
    };

    return (
        <Card {...props}>
            <CardHeader
                action={(
                    <Button
                        endIcon={<ArrowDropDownIcon fontSize="small"/>}
                        size="small"
                    >
                        Last 7 days
                    </Button>
                )}
                title="Some random chart"
            />
            <Divider/>
            <CardContent>
                <Box
                    sx={{
                        height: 400,
                        position: 'relative'
                    }}
                >
                    <Bar
                        data={data}
                        options={options}
                    />
                </Box>
            </CardContent>
            <Divider/>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    p: 2
                }}
            >
                <Button
                    color="primary"
                    endIcon={<ArrowRightIcon fontSize="small"/>}
                    size="small"
                >
                    Overview
                </Button>
            </Box>
        </Card>
    );
};

export const TotalUsers = (props) => {
    const dispatch = useDispatch();
    const users = useSelector((state) => state.user.users);

    const [showSnack, setShowSnack] = useState(false);

    const refreshClicked = async () => {
        console.log('refreshClicked')
        dispatch(getUsers(true));
        setShowSnack(true);
    }

    const handleClose = () => {
        setShowSnack(false);
    }

    if (users.length == 0) {
        return (<Loader/>);
    }

    let titleText = `Total Users: ${users.length}`;
    let cachedUsersDate = localStorage.getItem(CACHE_KEY.USERS_CACHE_DATE) ? JSON.parse(localStorage.getItem(CACHE_KEY.USERS_CACHE_DATE)) : '';

    return (
        <>
            <Card {...props}>
                <Box
                    sx={{
                        pl: 4,
                        pt: 1,
                        position: 'relative'
                    }}
                >
                    <Typography
                        fontSize={24}
                    >
                        {titleText}
                    </Typography>
                    <Box sx={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                        <Typography
                            color="gray"
                            fontSize={12}
                        >
                            {`Last updated on: ${toDateTime(cachedUsersDate, 'YYYY/MM/DD HH:mm:ss')}`}
                        </Typography>
                        <Tooltip title="Force user refresh">
                            <IconButton color="primary" onClick={refreshClicked}>
                                <RefreshIcon/>
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Box>
            </Card>
            <Snackbar open={showSnack} autoHideDuration={3000} onClose={handleClose}
                      anchorOrigin={{vertical: 'top', horizontal: 'center'}}>
                <Alert onClose={handleClose} severity="success" sx={{width: '100%'}}>
                    User data refreshed
                </Alert>
            </Snackbar>
        </>
    );
}

export const UsersByGender = (props) => {
    const theme = useTheme();

    const users = useSelector((state) => state.user.users);

    if (users.length == 0) {
        return (<Loader/>);
    }

    let menCount = users.filter(x => x.gender == 'Male').length;
    let womenCount = users.filter(x => x.gender == 'Female').length;
    let nonBinaryCount = users.filter(x => x.gender == 'Non-Binary').length;

    const data = {
        datasets: [
            {
                data: [menCount, womenCount, nonBinaryCount],
                backgroundColor: ['#3F51B5', '#e53935', '#FB8C00'],
                borderWidth: 8,
                borderColor: '#FFFFFF',
                hoverBorderColor: '#FFFFFF'
            }
        ],
        labels: ['Men', 'Women', 'Non-Binary']
    };

    const options = {
        animation: false,
        cutoutPercentage: 80,
        layout: {padding: 0},
        legend: {
            display: false
        },
        maintainAspectRatio: false,
        responsive: true,
        tooltips: {
            backgroundColor: theme.palette.background.paper,
            bodyFontColor: theme.palette.text.secondary,
            borderColor: theme.palette.divider,
            borderWidth: 1,
            enabled: true,
            footerFontColor: theme.palette.text.secondary,
            intersect: false,
            mode: 'index',
            titleFontColor: theme.palette.text.primary
        }
    };

    const gender = [
        {
            title: 'Men',
            value: parseInt(((menCount) / users.length) * 100),
            icon: ManIcon,
            color: '#3F51B5'
        },
        {
            title: 'Women',
            value: parseInt((womenCount / users.length) * 100),
            icon: WomanIcon,
            color: '#E53935'
        },
        {
            title: 'Non-Binary',
            value: parseInt((nonBinaryCount / users.length) * 100),
            icon: QuestionMarkIcon,
            color: '#FB8C00'
        }
    ];

    return (
        <Card {...props}>
            <CardHeader title="Users By Gender"/>
            <Divider/>
            <CardContent>
                <Box
                    sx={{
                        height: 300,
                        position: 'relative'
                    }}
                >
                    <Doughnut
                        data={data}
                        options={options}
                    />
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        pt: 2
                    }}
                >
                    {gender.map(({
                                     color,
                                     icon: Icon,
                                     title,
                                     value
                                 }) => (
                        <Box
                            key={title}
                            sx={{
                                p: 1,
                                textAlign: 'center'
                            }}
                        >
                            <Icon color="action"/>
                            <Typography
                                color="textPrimary"
                                variant="body1"
                            >
                                {title}
                            </Typography>
                            <Typography
                                style={{color}}
                                variant="h4"
                            >
                                {value}
                                %
                            </Typography>
                        </Box>
                    ))}
                </Box>
            </CardContent>
        </Card>
    );
};

export const UsersByAgeRange = (props) => {
    const theme = useTheme();

    const users = useSelector((state) => state.user.users);

    if (users.length == 0) {
        return (<Loader/>);
    }

    const getAgeGroups = (users) => {
        let age18To29 = [];
        let age30To39 = [];
        let age40To49 = [];
        let age50To59 = [];
        let age60To69 = [];
        let age70Plus = [];

        for (let user of users) {
            let age = getAge(user.dob);

            if (age >= 18 && age < 30) {
                age18To29.push(user);
            } else if (age >= 31 && age < 40) {
                age30To39.push(user);
            } else if (age >= 41 && age < 50) {
                age40To49.push(user);
            } else if (age >= 51 && age < 60) {
                age50To59.push(user);
            } else if (age >= 61 && age < 70) {
                age60To69.push(user);
            } else if (age >= 70) {
                age70Plus.push(user);
            }
        }

        let ageGroups = {age18To29, age30To39, age40To49, age50To59, age60To69, age70Plus};

        return ageGroups;
    }

    let ageGroups = getAgeGroups(users);
    let age18To29Count = ageGroups?.age18To29 ? ageGroups?.age18To29.length : 0;
    let age30To39Count = ageGroups?.age30To39 ? ageGroups?.age30To39.length : 0;
    let age40To49Count = ageGroups?.age40To49 ? ageGroups?.age40To49.length : 0;
    let age50To59Count = ageGroups?.age50To59 ? ageGroups?.age50To59.length : 0;
    let age60To69Count = ageGroups?.age60To69 ? ageGroups?.age60To69.length : 0;
    let age70PlusCount = ageGroups?.age70Plus ? ageGroups?.age70Plus.length : 0;

    let totalAgeGroupCount = age18To29Count + age30To39Count + age40To49Count + age50To59Count + age60To69Count + age70PlusCount;

    const data = {
        datasets: [
            {
                data: [ageGroups.age18To29.length, ageGroups.age30To39.length, ageGroups.age40To49.length, ageGroups.age50To59.length, ageGroups.age60To69.length, ageGroups.age70Plus.length],
                backgroundColor: ['#3F51B5', '#e53935', '#FB8C00', '#934ee2', '#e1ca44', '#79a445'],
                borderWidth: 8,
                borderColor: '#FFFFFF',
                hoverBorderColor: '#FFFFFF'
            }
        ],
        labels: ['18-29', '30-39', '40-49', '50-59', '60-69', '70+']
    };

    const options = {
        animation: false,
        cutoutPercentage: 80,
        layout: {padding: 0},
        legend: {
            display: false
        },
        maintainAspectRatio: false,
        responsive: true,
        tooltips: {
            backgroundColor: theme.palette.background.paper,
            bodyFontColor: theme.palette.text.secondary,
            borderColor: theme.palette.divider,
            borderWidth: 1,
            enabled: true,
            footerFontColor: theme.palette.text.secondary,
            intersect: false,
            mode: 'index',
            titleFontColor: theme.palette.text.primary
        }
    };


    const agePercent = [
        {
            title: '18-29',
            icon: CribIcon,
            value: getInt((age18To29Count / totalAgeGroupCount) * 100),
            color: '#3F51B5'
        },
        {
            title: '30-39',
            icon: AutoGraphIcon,
            value: getInt((age30To39Count / totalAgeGroupCount) * 100),
            color: '#E53935'
        },
        {
            title: '40-49',
            icon: AutoGraphIcon,
            value: getInt((age40To49Count / totalAgeGroupCount) * 100),
            color: '#FB8C00'
        },
        {
            title: '50-59',
            icon: AutoGraphIcon,
            value: getInt((age50To59Count / totalAgeGroupCount) * 100),
            color: '#934ee2'
        },
        {
            title: '60-69',
            icon: AutoGraphIcon,
            value: getInt((age60To69Count / totalAgeGroupCount) * 100),
            color: '#e1ca44'
        },
        {
            title: '70+',
            icon: ElderlyWomanIcon,
            value: getInt((age70PlusCount / totalAgeGroupCount) * 100),
            color: '#79a445'
        },
    ];

    return (
        <Card {...props}>
            <CardHeader title="Users By Age"/>
            <Divider/>
            <CardContent>
                <Box
                    sx={{
                        height: 300,
                        position: 'relative'
                    }}
                >
                    <Doughnut
                        data={data}
                        options={options}
                    />
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        pt: 2
                    }}
                >
                    {agePercent.map(({
                                         color,
                                         icon: Icon,
                                         title,
                                         value
                                     }) => (
                        <Box
                            key={title}
                            sx={{
                                p: 1,
                                textAlign: 'center'
                            }}
                        >
                            <Icon color="action"/>
                            <Typography
                                color="textPrimary"
                                variant="body1"
                                fontSize={10}
                            >
                                {title}
                            </Typography>
                            <Typography
                                style={{color, fontSize: 12}}
                                variant="h6"
                            >
                                {value}
                                %
                            </Typography>
                        </Box>
                    ))}
                </Box>
            </CardContent>
        </Card>
    );
};

export const UsersByState = (props) => {
    const theme = useTheme();

    const users = useSelector((state) => state.user.users);

    if (users.length == 0) {
        return (<Loader/>);
    }

    const getTopLocations = (users) => {

        let stateData = {};

        for (let user of users) {
            let state = user.addressInfo?.state;

            if (!state) {
                continue;
            }

            if (state.length > 2) {
                continue;
            }

            if (!(state in stateData)) {
                stateData[state] = 0;
            }

            stateData[state] = stateData[state] + 1;
        }

        return stateData;
    }

    let topLocations = getTopLocations(users);
    let topLocationsCount = Object.keys(topLocations).length;
    let randomHexColors = generateRandomHexColors(topLocationsCount);

    const data = {
        datasets: [
            {
                data: Object.values(topLocations),
                backgroundColor: randomHexColors,
                borderWidth: 8,
                borderColor: '#FFFFFF',
                hoverBorderColor: '#FFFFFF'
            }
        ],
        labels: Object.keys(topLocations)
    };

    const options = {
        animation: false,
        cutoutPercentage: 80,
        layout: {padding: 0},
        legend: {
            display: false
        },
        maintainAspectRatio: false,
        responsive: true,
        tooltips: {
            backgroundColor: theme.palette.background.paper,
            bodyFontColor: theme.palette.text.secondary,
            borderColor: theme.palette.divider,
            borderWidth: 1,
            enabled: true,
            footerFontColor: theme.palette.text.secondary,
            intersect: false,
            mode: 'index',
            titleFontColor: theme.palette.text.primary
        }
    };

    return (
        <Card {...props}>
            <CardHeader title="Users By State"/>
            <Divider/>
            <CardContent>
                <Box
                    sx={{
                        height: 300,
                        position: 'relative'
                    }}
                >
                    <Doughnut
                        data={data}
                        options={options}
                    />
                </Box>
            </CardContent>
        </Card>
    );
};
